import { Flex, Icon, Text } from '@cad-arc';
import {
    CorrectedFirearm,
    CorrectedOtherItem,
    EntityTypes,
    MergedEntityTypes,
    Property,
} from '../../../../../fr-entity-panels/types';
import { EventDrugsDto } from '@mark43/cad-api';

function FirearmTileFields({
    firearm,
    entityType,
}: {
    firearm: CorrectedFirearm;
    entityType: EntityTypes | MergedEntityTypes;
}) {
    const { firearmMake, caliber, description, serialNumber } = firearm;

    return (
        <>
            <Flex margin={0} padding={0} alignItems="center" gap="5px">
                <Text fontWeight="bold" fontSize="md" style={{ wordBreak: 'break-word' }}>
                    {serialNumber}
                </Text>
                {Object.values(MergedEntityTypes).includes(entityType as MergedEntityTypes) && (
                    <Icon icon="Merge" />
                )}
            </Flex>
            {firearmMake?.label && (
                <Text fontSize="sm" color="tertiary" style={{ marginTop: 0 }}>
                    {firearmMake.label}
                </Text>
            )}
            {caliber && (
                <Text fontWeight="semibold" fontSize="sm" color="tertiary" style={{ marginTop: 0 }}>
                    {caliber.label}
                </Text>
            )}
            {description && (
                <Text fontWeight="semibold" fontSize="sm" color="tertiary" style={{ marginTop: 0 }}>
                    {description}
                </Text>
            )}
        </>
    );
}

function DrugTileFields({
    drug,
    entityType,
}: {
    drug: EventDrugsDto;
    entityType: EntityTypes | MergedEntityTypes;
}) {
    const { measurementUnits, drugCategory, description, quantity } = drug;

    return (
        <>
            <Flex margin={0} padding={0} alignItems="center" gap="5px">
                <Text fontWeight="bold" fontSize="md" style={{ wordBreak: 'break-word' }}>
                    {drugCategory?.label}
                </Text>
                {Object.values(MergedEntityTypes).includes(entityType as MergedEntityTypes) && (
                    <Icon icon="Merge" />
                )}
            </Flex>
            {quantity && (
                <Text fontWeight="semibold" fontSize="sm" color="tertiary" style={{ marginTop: 0 }}>
                    {quantity} {measurementUnits && measurementUnits?.label}
                </Text>
            )}
            <Text fontWeight="semibold" fontSize="sm" color="tertiary" style={{ marginTop: 0 }}>
                {description ? description : 'No description'}
            </Text>
        </>
    );
}

function OtherItemTileFields({
    otherItem,
    entityType,
}: {
    otherItem: CorrectedOtherItem;
    entityType: EntityTypes | MergedEntityTypes;
}) {
    const { itemCategory, description, quantity, serialNumber } = otherItem;

    return (
        <>
            <Flex margin={0} padding={0} alignItems="center" gap="5px">
                <Text fontWeight="bold" fontSize="md" style={{ wordBreak: 'break-word' }}>
                    {serialNumber}
                </Text>
                {Object.values(MergedEntityTypes).includes(entityType as MergedEntityTypes) && (
                    <Icon icon="Merge" />
                )}
            </Flex>
            {itemCategory && (
                <Text fontWeight="semibold" fontSize="sm" color="tertiary" style={{ marginTop: 0 }}>
                    {itemCategory.label}
                    {quantity && ` ${quantity}`}
                </Text>
            )}
            <Text fontWeight="semibold" fontSize="sm" color="tertiary" style={{ marginTop: 0 }}>
                {description ? description : 'No description'}
            </Text>
        </>
    );
}

export function PropertyCardTileFields({
    property,
    entityType,
}: {
    property: Property;
    entityType: EntityTypes | MergedEntityTypes;
}) {
    if (entityType.includes('firearms') || entityType.includes('mergedFirearms'))
        return <FirearmTileFields firearm={property as CorrectedFirearm} entityType={entityType} />;
    if (entityType.includes('drugs') || entityType.includes('mergedDrugs'))
        return <DrugTileFields drug={property as EventDrugsDto} entityType={entityType} />;
    if (entityType.includes('otherItems') || entityType.includes('mergedOtherItems'))
        return (
            <OtherItemTileFields
                otherItem={property as CorrectedOtherItem}
                entityType={entityType}
            />
        );
    return <></>;
}
